import { render, staticRenderFns } from "./milkProductionPerfomanceOfTheCow.vue?vue&type=template&id=6c041bd7&scoped=true&"
import script from "./milkProductionPerfomanceOfTheCow.vue?vue&type=script&lang=js&"
export * from "./milkProductionPerfomanceOfTheCow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c041bd7",
  null
  
)

export default component.exports